import { render, staticRenderFns } from "./TixstockHeader.vue?vue&type=template&id=9b6ddcac&scoped=true"
import script from "./TixstockHeader.vue?vue&type=script&lang=js"
export * from "./TixstockHeader.vue?vue&type=script&lang=js"
import style0 from "./TixstockHeader.vue?vue&type=style&index=0&id=9b6ddcac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b6ddcac",
  null
  
)

export default component.exports